import { Box, Typography } from "@mui/material";
import { useContext } from "react";
import { MainContextState, MainContext } from "../../../../context/MainContext";
import { ReportTableCreator } from "./ReportTableCreator";
import { form5Rows, form5HeaderRows } from "../helpers/form5";

interface IProps {
    editForm?: boolean;
}

export const Form5EditForm = ({ editForm = false }: IProps) => {
    const { constants } = useContext<Partial<MainContextState>>(MainContext);

    const isOwner =
        localStorage.getItem("employee_type") == "16" &&
        localStorage.getItem("employee_center_id") == localStorage.getItem("current_center_id");

    return (
        <>
            <Box sx={{ p: 2 }}>
                <Typography variant="h5" fontWeight={"bold"} textAlign={"left"}>
                    Форма 5
                </Typography>
            </Box>
            <ReportTableCreator bodyCell={form5Rows} header={form5HeaderRows} />
        </>
    );
};
